import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../state";

export const createRequestor = createAsyncThunk('createRequestor', async (data: any) => {
    try {
        const response = await axios({
            method: 'post',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/requestor',
            data: data
        })
        return response
    } catch (error: any) {
        return error.response
    }
})

export const deleteRequestor = createAsyncThunk('deleteRequestor', async (id: string) => {
    try {
        const response = await axios({
            method: 'delete',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/requestor?id=' + id,
        })
        return response
    } catch (error: any) {
        return error.response
    }
})

export const editRequestor = createAsyncThunk('editRequestor', async (data: any) => {
    try {
        const response = await axios({
            method: 'put',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/requestor',
            data: data
        })
        return response
    } catch (error: any) {
        return error.response
    }
})